<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [multiSelect]="false"
    [gridName]="'essayExamLogGrid'"
    (refreshDataFromServer)="refreshData($event)"
   (rowSelected)="onRowClick($event)"
></app-grid>